import React, { FC } from "react";
import EPGAdminLayout from "../../../layouts/admin/EPGAdminLayout";
import { useChannelTagsWithPipelineNames, usePlanbyChannels } from "../../../services/epg/Query";
import IngestTriggerCard from "./components/ingest/IngestTriggerCard";

const EPGIngestView: FC = () => {
    const { data: channels = [] } = usePlanbyChannels();
    const { data: channelTagsWithPipelineNames } = useChannelTagsWithPipelineNames();

    const channelNamesWithPipelineNames = channels.map((channel) => {
        return {
            channelName: channel.name ?? "",
            pipelineName: channelTagsWithPipelineNames ? channelTagsWithPipelineNames[channel.uuid] : "",
            uuid: channel.uuid ?? "",
        };
    });

    return (
        <>
            <EPGAdminLayout heading = "EPG Ingest">
                <div className = {`px-4`}>
                    <div className = {`w-3/4 flex flex-col gap-6 pb-20`}>
                        <IngestTriggerCard heading={"Automated Ingests"} subHeading={`Trigger all automated ingests`} ingestType={{ label: "ALL_AUTOMATED" }}/>
                        <IngestTriggerCard
                            channels={channelNamesWithPipelineNames}
                            heading={"Automated Ingest"}
                            subHeading={`Trigger specific automated ingest`}
                            ingestType={{ label: "SPECIFIC_AUTOMATED" }}
                        />
                        <IngestTriggerCard
                            channels={channelNamesWithPipelineNames}
                            heading={"Manual Metadata Ingest"}
                            subHeading={`Upload specific channel Metadata`}
                            ingestType={{ label: "METADATA_MANUAL" }}
                        />
                        <IngestTriggerCard
                            channels={channelNamesWithPipelineNames}
                            heading={"Manual Image Library Ingest"}
                            subHeading={`Upload specific channel Images`}
                            ingestType={{ label: "IMAGES_MANUAL" }}
                        />
                    </div>
                </div>
            </EPGAdminLayout>
        </>
    );
};

export default EPGIngestView;